<script setup lang="ts">

import { useViewModelInstance } from "@app/MyGarage/Types/MyGarageViewModelStore";

const viewModel = await useViewModelInstance();

</script>

<template>

    <div class="p-4 3xl:p-6 bg-gray-800 rounded-lg">
        <div class="flex flex-col flex-1">
            <h1 class="flex-1 flex flex-col text-base lg:text-lg 3xl:text-xl">
                Need access to your documents?
            </h1>
            <span class="text-white/60 mt-1 text-xs lg:text-sm 3xl:text-lg">
                Holds all the important details and documents for your vehicle's products, in one place
            </span>
        </div>
        <Button to="/my-garage/care-plan"
                variant="tonal"
                class="flex w-full !h-10 lg:!h-12 3xl:!h-14 mt-4">
            <Icon name="keys" 
                  class="text-3xl opacity-70 !hidden sm:!block mr-1 lg:mr-2" />
            <span class="3xl:text-base">
                Open Product Details
            </span>
        </Button>
    </div>

</template>